import WebUtils from "../utils/WebUtils";

export const addtoScreenShareQueue = (
  formData,
  apiScreenShareQueue,
  screenShareBlobQueueRef,
  formUrl,
  screenShareRejoinApiFlag,
  screenRejoinApi
) => {
  const queueItem = {
    formData,
    rejoinFlag: screenShareRejoinApiFlag.current,
  };
  apiScreenShareQueue.current.push(queueItem);
  screenShareBlobQueueRef.current.push(formData);

  screenShareRejoinApiFlag.current = false;
  // console.log("Api Screen queue", apiScreenShareQueue.current);
  // console.log("Screen queue", screenShareBlobQueueRef.current);

  if (apiScreenShareQueue.current.length === 1) {
    processScreenShareQueue(
      apiScreenShareQueue,
      screenShareBlobQueueRef,
      formUrl,
      screenRejoinApi
    );
  }
};

const processScreenShareQueue = async (
  apiScreenShareQueue,
  screenShareBlobQueueRef,
  formUrl,
  screenRejoinApi
) => {
  while (apiScreenShareQueue.current.length > 0) {
    const item = apiScreenShareQueue.current[0];
    const { formData } = item;

    try {
      await makeScreenShareApiCall(
        formData,
        item.rejoinFlag ? true : false,
        formUrl,
        screenRejoinApi
      );
    } catch (error) {
      console.error("Error uploading video", error);
    } finally {
      apiScreenShareQueue.current.shift();
      screenShareBlobQueueRef.current.shift();
    }
  }
};

const makeScreenShareApiCall = async (
  formData,
  rejoinFlag,
  formUrl,
  screenRejoinApi
) => {
  return WebUtils.httpOperations(formUrl, formData, "POST")
    .then((response) => {
      if (response.data.resultStatusInfo.resultCode === "SUCCESS") {
        if (rejoinFlag) {
          screenRejoinApi();
        }
      }
    })
    .catch((err) => console.error(err));
};
